(function () {
  let swiperInstance = null;
  const mobileBreakpoint = 769;

  const initOrDestroySlider = (section) => {
    const slider = section.querySelector(".banner-grid-section__swiper");
    if (!slider) return;
    const isMobile = window.innerWidth < mobileBreakpoint;
    if (isMobile) {
      if (swiperInstance) return;
      const columns = Number(slider.dataset.columns) || 1;
      const columnsConfig = {
        4: { 750: { slidesPerView: 1 } },
        3: { 750: { slidesPerView: 1 } },
        2: { },
        1: { },
      };

      swiperInstance = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        speed: 800,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: section.querySelector('.cards-grid__navigation-button-next'),
          prevEl: section.querySelector('.cards-grid__navigation-button-prev'),
          disabledClass: "swiper-button-disabled",
        },
        breakpoints: columnsConfig[columns] || {},
      });
    } else {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
        slider.removeAttribute('style');
      }
    }
  };
  const currentSection = document.currentScript.parentElement;
  initOrDestroySlider(currentSection);
  document.addEventListener("shopify:section:load", function (event) {
    initOrDestroySlider(event.target);
  });
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initOrDestroySlider(currentSection);
    }, 150);
  });
})();